import React, { useState, useEffect } from 'react';
import './faqSelection.css';

const themeConfig = {
    ibcb: { icon: "fa-users", label: "IBCB" },
    financial_inclusion: { icon: "fa-coins", label: "FINANCIAL INCLUSION" },
    farm: { icon: "fa-tractor", label: "FARM" },
    non_farm: { icon: "fa-store", label: "NON - FARM" },
    livestock: { icon: "fa-cow", label: "LIVESTOCK" },
    jobs: { icon: "fa-briefcase", label: "JOBS" },
    hns: { icon: "fa-apple-alt", label: "HNS" },
    social_development: { icon: "fa-hands-helping", label: "SOCIAL DEVELOPMENT" },
    saturation_report: { icon: "fa-tint", label: "SATURATION REPORT" },
    hrmis: { icon: "fa-user-tie", label: "HRMIS" },
    sjy: { icon: "fa-home", label: "SJY" }
};

const FaqSelection = ({ onQuestionSelect, onBack }) => {
    const [themes, setThemes] = useState({});
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('https://flask.brlps.in/themes')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch themes');
                }
                return response.json();
            })
            .then(data => {
                setThemes(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching themes:", err);
                setError("Failed to load themes. Please try again later.");
                setLoading(false);
            });
    }, []);

    const handleThemeClick = (themeName) => {
        setSelectedTheme(themeName);
    };

    const handleBackToThemes = () => {
        setSelectedTheme(null);
    };

    if (loading) {
        return <div className="faq-loading">Loading themes...</div>;
    }

    if (error) {
        return <div className="faq-error">{error}</div>;
    }

    // Sort themes based on the order in themeConfig (optional, but good for consistency)
    const sortedThemeKeys = Object.keys(themes).sort((a, b) => {
        const indexA = Object.keys(themeConfig).indexOf(a);
        const indexB = Object.keys(themeConfig).indexOf(b);
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    });

    return (
        <div className="faq-selection-container">
            {selectedTheme ? (
                <div className="questions-view">
                    <div className="faq-header">
                        <button className="back-btn" onClick={handleBackToThemes}>
                            <i className="fas fa-arrow-left"></i> Back
                        </button>
                        <div className="faq-header-content">
                            <h3>Frequently asked Questions in {themeConfig[selectedTheme]?.label || selectedTheme.replace(/_/g, ' ').toUpperCase()}</h3>
                            <h2>Click on Question to get the answer or you can ask such type of Question in Chat Mode</h2>
                        </div>
                    </div>
                    <div className="questions-list">
                        {themes[selectedTheme]?.map((example, index) => (
                            <div
                                key={index}
                                className="question-card"
                                onClick={() => onQuestionSelect(example.input)}
                            >
                                <p>{example.input}</p>
                            </div>
                        ))}
                        {themes[selectedTheme]?.length === 0 && (
                            <div className="no-questions">No questions available for this theme yet.</div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="themes-view">
                    <h3 className="themes-headline">Select Theme</h3>
                    <div className="themes-grid">
                        {sortedThemeKeys.map((themeName) => {
                            const config = themeConfig[themeName] || { icon: "fa-folder", label: themeName.replace(/_/g, ' ').toUpperCase() };
                            return (
                                <div
                                    key={themeName}
                                    className="theme-card-rect"
                                    onClick={() => handleThemeClick(themeName)}
                                >
                                    <div className="theme-icon">
                                        <i className={`fas ${config.icon}`}></i>
                                    </div>
                                    <span className="theme-label">{config.label}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FaqSelection;
